export default "__VITE_ASSET__B04TDiA$__"